import type { IStorageService } from '../../domain/ports';
import type { UserProfile } from '../../application/dto/dtos';
import { authStorage } from '../services';

/**
 * Adapte authStorage vers le port IStorageService.
 */
export class StorageServiceImpl implements IStorageService {
  setUser(user: UserProfile): void {
    authStorage.setUser(user);
  }

  getUser(): UserProfile | null {
    return authStorage.getUser<UserProfile>();
  }

  clearUser(): void {
    authStorage.clearUser();
  }

  clearAll(): void {
    authStorage.clearAll();
  }
}
